import queryString from 'query-string';

import { SEARCH_PARAMS } from './constants';

/**
 *  utitlity functions
 */

export function handleDefaults(defaultObj, dynamicObj) {
  for (const key in dynamicObj) {
    defaultObj[key] = dynamicObj[key];
  }
  return defaultObj;
}

export function getConfiguration(name) {
  if (window._env_) {
    return window._env_[name];
  }

  return '';
}

export function log() {}

export function getContextCoords(position, modalWidth, leftAlign = false) {
  const leftOffset = position.left || position.x || position.clientX;
  const innerOffsetRight = window.innerWidth - (position.right || position.clientX);
  const innerOffsetLeft = leftOffset - modalWidth;
  const coords = {};

  coords.height = position.height;

  if (leftAlign) {
    const mid = (position.top + position.bottom) / 2;
    coords.posX = position.right + 11;
    coords.posArrow = position.right + 8;
    coords.posArrowY = mid - 8;
    coords.posY = innerHeight - position.bottom < 85 ? position.bottom - 150 : position.bottom - 75;
    return coords;
  }
  coords.posY = (position.bottom || position.clientY) + 5;
  coords.posArrow = leftOffset + (position.width || 2) / 2;
  if (innerOffsetRight > modalWidth && innerOffsetLeft > modalWidth) {
    coords.posX = coords.posArrow - modalWidth / 2; // center aligned
  } else if (innerOffsetLeft < modalWidth && innerOffsetRight > modalWidth) {
    coords.posX = coords.posArrow - 15; // left aligned
  } else {
    coords.posX = coords.posArrow - modalWidth + 15; // right aligned
  }
  return coords;
}

export const findCountryCodeFromQueryParams = () => {
  const queryStringSearch = queryString.parse(window.location.search);

  return queryStringSearch[SEARCH_PARAMS.COUNTRY_CODE_PARAM] || 'AUS';
};

export const findRegionCodeFromQueryParams = () => {
  const queryStringSearch = queryString.parse(window.location.search);

  return queryStringSearch[SEARCH_PARAMS.REGION_CODE_PARAM] || null;
};

export const findOption = (options, selectedOption) => options.find(option => option.value === selectedOption?.value);

export const isDefined = value => ![null, undefined].includes(value);

export const getQueryParam = (param) => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(param);
};



// WEBPACK FOOTER //
// ./helpers/utils.js